import { Icon } from '@dixa/lib-shared-habla';
import { basicBlockActions } from 'articleEditor/utils/actions';
import cx from 'classnames';
import { useMemo } from 'react';

import { SortableBlockWrapper } from '../baseBlock';
import s from '../baseBlock/block.module.scss';
import { HtmlBlockProps } from './htmlBlock';

type HtmlBlockPlaceholderProps = HtmlBlockProps & {
  onEditHtmlBlock: () => void;
};

export default function HtmlBlockPlaceholder({
  attributes,
  element,
  onEditHtmlBlock,
  children,
}: HtmlBlockPlaceholderProps): JSX.Element {
  const blockActions = useMemo(() => [...basicBlockActions], []);

  return (
    <SortableBlockWrapper
      className={s['blockImagePlaceholder']}
      element={element}
      blockActions={blockActions}
    >
      <div
        {...attributes}
        className={cx(s['mediaUploadArea'], s['blockContent'])}
        onClick={onEditHtmlBlock}
        contentEditable={false}
      >
        <Icon className={s['mediaUploadAreaIcon']} name="cloud-upload" />
        {/* TODO: Drag & drop a HTML file, or click to edit... */}
        <div className={s['mediaUploadAreaText']}>Click to edit...</div>
      </div>
      {children}
    </SortableBlockWrapper>
  );
}
